module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sign-up-complete"
  }, [_c('header-bar'), _vm._v(" "), _c('section', {
    staticClass: "background-image"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('h2', [_vm._v("Thanks " + _vm._s(this.$root.profile.firstname) + "!")]), _vm._v(" "), _c('p', [_vm._v("You're profile is now complete.")]), _vm._v(" "), _c('p', [_vm._v("You can match, connect, exchange and make big ideas for Africa happen!")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-big bg-four active",
    attrs: {
      "to": "/matches"
    }
  }, [_vm._v("Discover your matches")])], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57468f6a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/register/Register-Step-10.vue
// module id = 711
// module chunks = 1